module.exports = __webpack_public_path__ + "img/badges.dd2a45a6.svg";